module.exports = __webpack_public_path__ + "media/reskin-images/icon--settings-548941df.svg";